import React, { useState } from 'react';
import { Tabs } from 'antd';

const { TabPane } = Tabs;

const CustomTabs = ({ tabs, tabProps, customClass, ...rest }) => {
  const [activeTab, setActiveTab] = useState(tabs[0].id);
  const onChange = key => setActiveTab(key);
  return (
    <div className="custom-tabs">
      <Tabs
        defaultActiveKey={activeTab}
        onChange={onChange}
        className={`fullwidth-tabs ${customClass ? customClass : ''}`}
        {...rest}
      >
        {tabs.map(({ label, id, Component }, index) => (
          <TabPane key={index} tab={label}>
            <Component {...tabProps} />
          </TabPane>
        ))}
      </Tabs>
    </div>
  );
};

export default CustomTabs;
